__turbopack_context__.v({
  "showMoreTextContainer": "AboutTab-module-scss-module__Rjuh7q__showMoreTextContainer",
});
